// 创建全局状态管理器
class StateManager {
    constructor() {
      this.subscribers = [];
      this.state = {
        isSubmitting: false,
        showSuccess: false
      };
    }
    
    subscribe(callback) {
      this.subscribers.push(callback);
      return () => {
        this.subscribers = this.subscribers.filter(sub => sub !== callback);
      };
    }
    
    updateState(newState) {
      this.state = {...this.state, ...newState};
      this.subscribers.forEach(callback => callback(this.state));
    }
    
    getState() {
      return this.state;
    }
  }
  
  // 创建全局实例
  const globalStateManager = new StateManager();
  export default globalStateManager;